import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import startOfDay from 'date-fns/startOfDay';

import FormGroup from '../../../../../../components/global/FormGroup';
import PhoneInput from '../../../../../../components/global/PhoneInput';
import Alert from '../../../../../../components/global/Alert';
import { getFormikTouchedErrors } from '../../../../../../util/formik';
import Select from '../../../../../../components/global/Select';
import useVirtualPageView from '../../../../../pro/services/analytics/useVirtualPageView';
import Label from '../../../../../../components/global/Label';
import InputGroup from '../../../../../../components/global/InputGroup';
import { getAsset } from '../../../../../../util/assets';

const propTypes = {
  values: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    relationship: PropTypes.string,
    phone_number: PropTypes.string,
    couples_name: PropTypes.string,
    couples_phone_number: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
};

const RegistrationForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
}) => {
  useVirtualPageView({
    title: 'WaldoWed makes the perfect wedding gift! - Information',
    path: '/info',
  });

  const errorList = Object.values(
    getFormikTouchedErrors(errors, touched) ?? {},
  );
  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-6 col-12">
          <FormGroup
            id="first_name"
            name="first_name"
            label="Your first name"
            required
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.first_name}
          />
        </div>

        <div className="col-lg-6 col-12">
          <FormGroup
            id="last_name"
            name="last_name"
            label="Your last name"
            required
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.last_name}
          />
        </div>

        <div className="col-lg-6 col-12">
          <Select
            id="relationship"
            name="relationship"
            label="Relationship to couple"
            required
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.relationship}
          >
            <option value="">Relationship to couple&hellip;</option>
            <option value="Bride/Groom">Bride/Groom</option>
            <option value="Family">Family</option>
            <option value="Friend">Friend</option>
            <option value="Parent">Parent</option>
            <option value="Wedding Planner">Wedding Planner</option>
          </Select>
        </div>

        <div className="col-lg-6 col-12">
          <PhoneInput
            id="phone_number"
            value={values.phone_number || '+1'}
            label="Your Mobile Phone"
            onChange={phone => {
              handleChange({
                target: {
                  name: 'phone_number',
                  value: phone,
                },
              });
            }}
            className="mb-2"
          />
        </div>

        <div className="col-12">
          <div className="row">
            <FormGroup
              id="groom_name"
              name="groom_name"
              label="Who's getting married?"
              placeholder="Groom first name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.groom_name}
              className="freemium-bride-name-form-group col-12 col-lg-6"
            />
            <div className="col-12 d-lg-none text-center">&amp;</div>
            <FormGroup
              id="bride_name"
              name="bride_name"
              label={<>&nbsp;</>}
              labelProps={{
                className: 'd-none d-lg-block',
              }}
              className="col-12 col-lg-6"
              placeholder="Bride first name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.bride_name}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <Label id="date">Wedding date (Optional)</Label>
            <div className="datepicker-gray-light">
              <DatePicker
                id="date"
                required
                customInput={
                  <InputGroup
                    id="wedding_date"
                    name="wedding_date"
                    placeholder="Pick a date"
                    autocomplete="off"
                    readOnly
                    addon={
                      <img
                        alt=""
                        src={getAsset('/shutterbug/icons/calendar.svg')}
                      />
                    }
                  />
                }
                onKeyDown={e => {
                  e.preventDefault();
                }}
                popperClassName="freemium-event-date-picker-popper"
                wrapperClassName="freemium-event-date-picker"
                onChange={selectedDate => {
                  handleChange({
                    target: {
                      name: 'wedding_date',
                      value: startOfDay(selectedDate),
                    },
                  });
                }}
                selected={values.wedding_date}
              />
            </div>
          </div>
        </div>
      </div>

      {errorList?.length > 0 && (
        <Alert type="danger" className="mb-4">
          <ul className="mb-0">
            {errorList.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}
    </Fragment>
  );
};

RegistrationForm.propTypes = propTypes;

export default RegistrationForm;
